import type { EnrichedElasticSearchResponseFacet } from '@//utils/vehicles-search/useEnrichedFacets';
import { hasValidLocationInParams } from '@//utils/vehicles-search/utils';

interface FilterActiveState {
  isActive: boolean;
  count: number;
}

export const getFilterActiveState = (
  facet: EnrichedElasticSearchResponseFacet,
  searchParams: URLSearchParams,
): FilterActiveState => {
  if (facet.id === 'location') {
    return {
      isActive: hasValidLocationInParams(searchParams),
      count: hasValidLocationInParams(searchParams) ? 1 : 0,
    };
  }

  if (facet.type === 'range') {
    const hasMin = searchParams.has(`${facet.id}.min`);
    const hasMax = searchParams.has(`${facet.id}.max`);
    const isActive = hasMin || hasMax;
    return {
      isActive,
      count: isActive ? 1 : 0,
    };
  }

  // For toggle and other discrete filters
  const activeValues = new Set(searchParams.getAll(facet.id));
  return {
    isActive: activeValues.size > 0,
    count: activeValues.size,
  };
};
